import {SportstypeSpec} from "../types";
import start from "../../icons/handball/start";
import end from "../../icons/handball/end";
import goal from "../../icons/handball/goal";
import timeout from "../../icons/handball/timeout";
import turnover from "../../icons/handball/turnover";
import yellowCard from "../../icons/handball/yellow-card";
import redCard from "../../icons/handball/red-card";
import blueCard from "../../icons/handball/blue-card";
import suspensionTwo from "../../icons/handball/suspension-two";
import sevenMeter from "../../icons/handball/seven-meter";
import parry from "../../icons/handball/parry";
import freeThrow from "../../icons/handball/free-throw";
import main from "../../icons/handball/main";
import pauseHalves from "../../icons/handball/pause-halves";
import resumeHalves from "../../icons/handball/resume-halves";
import endOfRegularPlay from "../../icons/handball/end-of-regular-play";
import startOvertime from "../../icons/handball/start-overtime";
import pauseOvertime from "../../icons/handball/pause-overtime";
import resumeOvertime from "../../icons/handball/resume-overtime";
import endOfOvertime from "../../icons/handball/end-of-overtime";
import startShootout from "../../icons/handball/start-shootout";
import emptyGoal from "../../icons/handball/empty-goal";
import goalkeeperSubstitution from "../../icons/handball/goalkeeper-substitution";
import { initializeTeamGameScoreboard, scoreChange } from "../eventHandlerUtils";

const handball: SportstypeSpec = {
  id: 'handball',
  scoreboardType: 'team-game-scoreboard',
  isFastSportstype: true,
  svg: main,
  releaseStage: 'released',
  defaultTiming: {
    _type: "Tik::Model::Options::TimedGameOptions",
    num_regular_phases: 2,
    timing_type: "au",
    regular_phase_length: 30,
    overtime_phase_length: 5,
    num_overtime_phases: 2,
  },
  displayTimeFormat: "M'",
  displayPhaseFormat: "",
  displayPhaseOvertimeFormat: "extra-time",
  events: [
    {
      id: 'goal',
      important: true,
      svg: goal,
      team: 'any',
      eventHandler: scoreChange(1),
      players: [
        {id: 'scorer'},
        {id: 'assist'}
      ]
    },
    {
      id: 'parry',
      important: true,
      team: 'any',
      svg: parry,
      players: [
        {id: 'keeper'},
        {
          id: 'shooter',
          from: 'other-team'
        }
      ]
    },
    {
      id: 'seven-meter',
      important: true,
      svg: sevenMeter,
      team: 'any',
      players: [
        {id: 'shooter'},
        {
          id: 'keeper',
          from: 'other-team'
        }
      ]
    },
    {
      id: 'turnover',
      important: true,
      team: 'any',
      svg: turnover
    },
    {
      id: 'suspension-two',
      important: true,
      svg: suspensionTwo,
      team: 'any',
      players: [
        {id: 'offender'}
      ]
    },
    {
      id: 'yellow-card',
      important: true,
      svg: yellowCard,
      team: 'any',
      players: [
        {id: 'offender'}
      ]
    },
    {
      id: 'timeout',
      important: true,
      svg: timeout
    },
    {
      id: 'red-card',
      important: false,
      svg: redCard,
      team: 'any',
      players: [
        {id: 'offender'}
      ]
    },
    {
      id: 'blue-card',
      important: false,
      svg: blueCard,
      team: 'any',
      players: [
        {id: 'offender'}
      ]
    },
    {
      id: 'free-throw',
      important: false,
      svg: freeThrow
    },
    {
      id: 'empty-goal',
      important: true,
      team: 'any',
      svg: emptyGoal
    },
    {
      id: 'goalkeeper-substitution',
      important: false,
      team: 'any',
      players: [
        {id: 'in'},
        { id: 'out'}
      ],
      svg: goalkeeperSubstitution
    },
    {
      id: 'start',
      important: false,
      svg: start,
      eventHandler: initializeTeamGameScoreboard
    },
    {
      id: 'pause-halves',
      important: false,
      svg: pauseHalves
    },
    {
      id: 'resume-halves',
      important: false,
      svg: resumeHalves
    },
    {
      id: 'end-of-regular-play',
      important: false,
      svg: endOfRegularPlay
    },
    {
      id: 'start-overtime',
      important: false,
      svg: startOvertime
    },
    {
      id: 'pause-overtime',
      important: false,
      svg: pauseOvertime
    },
    {
      id: 'resume-overtime',
      important: false,
      svg: resumeOvertime
    },
    {
      id: 'end-of-overtime',
      important: false,
      svg: endOfOvertime
    },
    {
      id: 'start-shootout',
      important: false,
      svg: startShootout
    },
    {
      id: 'end',
      important: false,
      svg: end
    }
  ],
  legacyEventMap: {
    30: 'timeout',
    90: 'turnover',
    100: 'goal',
    201: 'yellow-card',
    202: 'red-card',
    212: 'suspension-two',
    250: 'seven-meter',
    259: 'parry',
    260: 'free-throw'
  }
}

export default handball
